import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { createOrder, createOrderFailure, createOrderSuccess, loadOrderSourcesList, loadOrderSourcesListSuccess, loadOrders, loadOrdersFailure, setOrderToComplete, updateOrder, updateOrderFailure, updateOrderSuccess } from './order.actions';
import { OrderService } from './order.service';
import { Router } from '@angular/router';

@Injectable()
export class OrderEffects {
  constructor(
    private actions$: Actions,
    private orderService: OrderService,
    private router: Router
  ) { }

  createOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createOrder),
      switchMap((action) =>
        this.orderService.createOrder(action.order).pipe(
          map(order => createOrderSuccess({ order })),
          catchError(error => of(createOrderFailure({ error })))
        )
      )
    )
  );

  updateOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateOrder),
      switchMap((action) =>
        this.orderService.updateOrder(action.order, action.orderId).pipe(
          map(order => updateOrderSuccess({ order })),
          tap(() => this.router.navigate(['app/order/home'])),
          catchError(error => of(updateOrderFailure({ error })))
        )
      )
    )
  );

  loadAllOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadOrderSourcesList),
      switchMap((action) =>
        this.orderService.getAllOrderSourcesList(action.from, action.to, action.column).pipe(
          map(orderSources => loadOrderSourcesListSuccess({ orderSources })),
          catchError(error => of(loadOrdersFailure({ error })))
        )
      )
    )
  );

  setOrderToCompleted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setOrderToComplete),
      switchMap((action) =>
        this.orderService.setOrderToCompleted(
          action.orderId,
          action.completedDate,
          action.receivedBy,
          action.podAttachments
        ).pipe(
          map(() => loadOrders()),
          tap(() => window.location.reload()),
          catchError(error => of(loadOrdersFailure({ error })))
        )
      )
    )
  );
}
